module.exports = __webpack_public_path__ + "src/app/_content/MINIFonts/fontello.ttf?377ea4b28c51302094f7a2c9df3ed08f";